import { createContext, useContext, useState, useCallback } from "react";
import classNames from "classnames";
import styles from "./toast.module.css";

const ToastContext = createContext();

export function Toast({
  type,
  message,
}) {
  return (
    <div className={classNames(styles.toast, { [styles.toastSuccess]: type === "success", [styles.toastError]: type === "error" })}>
      <p className={styles.toastTitle}>{type === "success" ? "успех" : "ошибка"}</p>
      <p>{message}</p>
    </div>
  );
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((message, type) => {
    const id = Math.random().toString(36).substring(2, 9); // Simple ID
    const toast = { id, message, type };
    setToasts((prev) => [...prev, toast]);

    setTimeout(() => removeToast(id), 6000);
  }, [removeToast]);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}

      <div className={styles.toastsContainer}>
        {toasts.map((toast) => (
          <Toast key={toast.id} type={toast.type} message={toast.message} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return {
    successToast: (msg) => context.addToast(msg, 'success'),
    errorToast: (msg) => context.addToast(msg, 'error'),
  };
}
